module.exports = __webpack_public_path__ + "db9367918b1aa6e08f487890e10fb61a.png";